import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import Table from "components/table/table";
import { useEffect, useState } from "react";
import FormDinamic from "./cadEditDinamic";
import PerfilService from "../../services/PerfilService";
import { useParams } from "react-router-dom";

const UserEventos = () => {
  const [cadEditDinamic, setCadEditDinamic] = useState(false);
  const [user, setUser] = useState({} as any);
  const { id }: any = useParams();

  const [dados, setDados] = useState(null);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    await PerfilService.getUserById(id)
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        //setLoading(false); // end loading
      });
  };

  const acao = (dados: any) => {
    setDados(dados);
    setCadEditDinamic(true);
  };

  const acaoCadastrar = () => {
    setDados(null);
    setCadEditDinamic(true);
  };

  const acaoCadastrado = (obj: any) => {
    setDados(null);
    setCadEditDinamic(false);
    setTimeout(() => {
      setCadEditDinamic(true);
      setDados(obj);
    }, 500);
  };

  return (
    <Layout user={user}>
      <LayoutDashboard>
        {!cadEditDinamic ? (
          <>
            {/* <div className="flex-end">
              <ButtonPrimary
                className="md:col-span-2"
                type="button"
                onClick={() => acaoCadastrar()}
              >
                Novo Evento
              </ButtonPrimary>
            </div>
            <br /> */}
            <div>
              <Table
                coluna1="Eventos"
                coluna2="Status"
                coluna3="Data"
                acao={acao}
                tipo="evento"
                rota={`/posts/${id}/user-events`}
                onlyView={true}  
              />
            </div>
          </>
        ) : (
          <FormDinamic
            nomeTela={"Evento"}
            tipoTela={4}
            acaoVoltar={setCadEditDinamic}
            dados={dados}
            acaoCadastrado={acaoCadastrado}
          />
        )}
      </LayoutDashboard>
    </Layout>
  );
};

export default UserEventos;
